let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7TdEl")).then(() => parcelRequire('dTxpY'));